import React, { FC } from 'react';
import styled from 'styled-components/native';

import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';
import { ECommonResponseCode, mapResponseCodeToMessage } from '@webtrader/core/request/message';

import Text from '@/components/Text';
import { ALL_MOBILE_ROUTES, navigate } from '@/utils/navigation';

interface IExperienceDemoCreationProps {
  loginErrorCode: ECommonResponseCode;
  setNeedUpdateFields?: (value: boolean) => void;
}

const ExperienceDemoCreation: FC<IExperienceDemoCreationProps> = (props) => {
  const { loginErrorCode, setNeedUpdateFields } = props;

  const { t } = useTranslation();

  const goToExperienceDemoDemoCreationScreen = () => {
    navigate(ALL_MOBILE_ROUTES.AUTH.EXPERIENCE_DEMO_CREATION, { setNeedUpdateFields });
  };

  return (
    <StyledErrorActionContainer>
      <StyledErrorText>{mapResponseCodeToMessage(loginErrorCode)}</StyledErrorText>
      <StyledLinkButton onPress={goToExperienceDemoDemoCreationScreen}>
        <StyledLinkLabelBold>{t('Register a new demo account here')}</StyledLinkLabelBold>
      </StyledLinkButton>
    </StyledErrorActionContainer>
  );
};

export default ExperienceDemoCreation;

export const StyledErrorText = styled(Text)`
  font-size: ${dynamicSize.convertSize(14)}px;
  color: ${({ theme }) => theme.colors.error[0]};
  margin: ${dynamicSize.convertSize(4)}px 0 0 0;
  text-align: center;
`;

const StyledLinkButton = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
`;

const StyledErrorActionContainer = styled.View`
  padding: ${dynamicSize.convertSize(12)}px 0 0 0;
  align-items: center;
`;

const StyledLinkLabelBold = styled(Text)`
  font-size: ${dynamicSize.convertSize(14)}px;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  margin-top: ${dynamicSize.convertSize(8)}px;
`;
